import Hashids from 'hashids'

const LOCAL_STORAGE_CART_REFERENCE = 'LOCAL_STORAGE/CART/REFERENCE'

export const formatPrice = item => {
  let priceDetails = Number(item.price).toFixed(2)
  if (item.recurring) {
    priceDetails += ' /'
    if (item.recurDetails.length > 1) {
      priceDetails += item.recurDetails.length + ' '
    }
    priceDetails += item.recurDetails.type === 'month' ? 'mo' : item.recurDetails.type
  }
  return priceDetails
}

const generateCartReference = () => {
  const hashids = new Hashids('xGy2KjZCtFrWjKdW', 32)
  const source = Math.floor(Math.random() * Math.floor(100000))
  return hashids.encode(source).substr(0, 32)
}

export const retrieveCartReference = () => {
  if (localStorage) {
    let localStorageReference = localStorage.getItem(LOCAL_STORAGE_CART_REFERENCE)
    if (localStorageReference === null) {
      localStorageReference = generateCartReference()
      localStorage.setItem(LOCAL_STORAGE_CART_REFERENCE, localStorageReference)
    }
    return localStorageReference
  } else {
    return generateCartReference()
  }
}

export const clearCartReference = () => {
  if (localStorage) {
    localStorage.removeItem(LOCAL_STORAGE_CART_REFERENCE)
  }
}

export const getMonthName = month => {
  const monthNames = [
    "01", "02", "03", "04", "05", "06","07", "08", "09", "10", "11", "12"
  ]
  return monthNames[month -1]
}
